module.exports = __webpack_public_path__ + "static/media/ad.2d96e17f.svg";